import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getListBonuses = () => {
    return axios.get(`${backendHost}/api/admin/bonuses/list`);
};

export {
    getListBonuses
}